import React from 'react'
import printConfig from '../../../print-config.json'
import requestStatusConstants from "../../../constants/requestStatus";
import actionTypes from '../../../actions/actionTypes';
import { PreviewPrintButtons } from './FlyerButtons';
import Translation from '../../Translation/cont/Translation';
import FlyerSettingsSection from './FlyerSettingsSection';
import getMoviesSortedAfterCurrentAndFuture from '../../../functions/getMoviesSortedAfterCurrentAndFuture';
import DragSourceWrapperWithDropzonesContainer from '../../../containers/dnd/DragSourceWrapperWithDropzonesContainer';
import { Form, Formik } from 'formik';
import dndItemTypes from '../../../constants/dndItemTypes'
import PrintWeekProgramFlyerChoosenMoviesListContainer from './PrintWeekProgramFlyerChoosenMoviesListContainer';
import Button from '../../general/Button';
import { MOVIE } from '../../../constants/itemTypes';
import { MASTERMULTITOTAL } from '../../../../../front/js/constants/multiCinemaModes';
import WrapperPageSpinner from '../../WrapperPage/present/WrapperPageSpinner';
import ListItemMovieContainer from '../../DragAndDropItems/cont/ListItemMovieContainer';



const PrintWeekProgramFlyer = ({
    cinemaId,
    printID,
    printType,
    landscape,
    requestStatus,
    requestError,
    requestOverlay,
    activeWeek,
    hasChanges,
    features,
    printWeekProgramFlyerRequest, 
    printUpdateRequest,
    onPrintFlyerPdfResetState,
    weekProgramFlyerSettings,
    updateWeekProgramFlyerSettings,
    weekProgramFlyerData,
    movies,
    order,
    currentCinemaId,
    performances,
    multicinemaMode,
    currentClientCinemaId,
    displayDropzones,
    bulkAddWeekProgramFlyerMovie,
    closePagePath,
    basicUrl
}) => {
    if(!features) {
        return ''
    }
    const {  requestType } = requestOverlay
    const { REQUEST_PENDING, REQUEST_SUCCESS, REQUEST_ERROR } = requestStatusConstants
    const isRequest =  actionTypes.PRINT_DATA_WEEKPROGRAMFLYER_PDF_REQUEST === requestType
    const errorMessage = requestError ? requestError.message : ''

    const buttonTextTransId = requestStatus === REQUEST_PENDING ? "print_week_program_flyer_is_generated" : requestStatus === REQUEST_ERROR ? "error_button": "print_week_program_flyer_generate"
    const displayDropzonesClass = displayDropzones ? ' dropzones single-dropzone' : ''
    const landscapeBoolean = landscape === "true"
    const currentPrintFormat = _.findWhere(printConfig.formats, { path: printID, landscape: landscapeBoolean })
    const currentPrintID = _.findKey(printConfig.formats, currentPrintFormat)
    const relevantMovies = {}
    let currentMovies = []
    let futureMovies = []

    // ToDo currentCinemaId = cinemaId  ????

    if(activeWeek === 'custom') {
        getMoviesSortedAfterCurrentAndFuture(order, movies, currentMovies, futureMovies, weekProgramFlyerData.currentWeek, currentCinemaId, performances, weekProgramFlyerData.dateSettings, currentClientCinemaId, multicinemaMode)
        const moviesInBothArrays = _.intersection(currentMovies, futureMovies)

        futureMovies = _.difference(futureMovies, moviesInBothArrays)

    } else {
        getMoviesSortedAfterCurrentAndFuture(order, movies, currentMovies, futureMovies, weekProgramFlyerData.currentWeek, currentCinemaId, performances, false, currentClientCinemaId, multicinemaMode)
    }
    
    _.keys(movies).map(movieId => {
        const movie = movies[movieId]
        
        if(multicinemaMode === MASTERMULTITOTAL || currentCinemaId === currentClientCinemaId) {
            relevantMovies[movieId] = movie
        } else {
            if(movie.cinemaIds.includes(currentCinemaId)) {
                relevantMovies[movieId] = movie
            }
        }
    })


    return (
        <WrapperPageSpinner
            pageTitle={[<Translation key="name_one" id={printConfig.routes[printType].transIdname} after={' / '}/>,activeWeek === 'custom' ? <Translation key="name_two" id="print_flyer_custom_date_period_title"/> : <Translation key="name_two" id="print_cw" after={' ' + activeWeek + ''}/>]}
            closePagePath={closePagePath}
        
            pending={isRequest && REQUEST_PENDING === requestStatus}
            error={isRequest && REQUEST_ERROR === requestStatus}
            success={isRequest && REQUEST_SUCCESS === requestStatus}
        
            pendingTextTransId='print_week_program_flyer_is_generated'
            errorTextTransId='print_flyer_error_occurred_while_generating'
            successTextTransId='print_flyer_PDF_successfully_generated'
        
            errorMsg={errorMessage}
            successMsg='Es befindet sich in dem Downloadordner oder ist über die Downloadhistorie des Browsers zu finden. Je nach Downloadeinstellung kann sich der Speicherort unterscheiden.'
        
            onClickSuccesButton={onPrintFlyerPdfResetState}
            onClickErrorButton={onPrintFlyerPdfResetState}
        >
            <div className="program-page program-page-sorting-movies flyer print-page site-content">
                {features.has_week_program_flyer ? (
               <div className="selections-item single-section">
               <div className="selections-item-content accordion-item">
                   <div className="selections-item-selections section-left">
                       <FlyerSettingsSection 
                           flyerSettings={weekProgramFlyerSettings}
                           printType={printType}
                           updateFlyerSettings={updateWeekProgramFlyerSettings}
                        />
                   </div>
                   <div className="selections-item-selections section-right print-details">
                        <Formik
                            initialValues={
                                weekProgramFlyerData
                            }
                            enableReinitialize
                            onSubmit={(values, actions) => {
                                // updateAllFlyerElements(values.choosenMovies.order, values.choosenMovies.items)
                            }}
                        >
                            {props => (
                                <Form>
                                    <div className="selections-item double-section">
                                        <div className="selections-item-content accordion-item">
                                            <p className="selection-drag-hint title-large-light"><Translation id="section_page_drag_movies_to_sort"/></p>
                                            <div className={"selections-item-selections section-left" + displayDropzonesClass}>
                                                <div className={"program-list "}>
                                                    <div className="program-list-wrapper">
                                                        <h3 className="title-list text-regular"><Translation id="section_filter_current_movies"/></h3>
                                                    </div>
                                                    <Button
                                                        className="button button-submit gap-30 " 
                                                        transId={'button_add_all_current_movies'}
                                                        onClick={()=>{bulkAddWeekProgramFlyerMovie(currentMovies)}}
                                                        hideText={false}
                                                    />  
                                                    <ul className="grid-container">
                                                        {currentMovies.map((itemId, index) => relevantMovies[itemId] && (
                                                            <li key={index} className="item-drag">
                                                                <DragSourceWrapperWithDropzonesContainer
                                                                    index={index}
                                                                    id={itemId}
                                                                    type={'movie'}
                                                                    dndType={dndItemTypes.WEEK_PROGRAM_FLYER_ITEM_AD}
                                                                    >
                                                                        <ListItemMovieContainer
                                                                            itemData={relevantMovies[itemId]}
                                                                            isSelected={props.values.choosenMovies.order.includes(itemId)}
                                                                            pathnameEdit={`${basicUrl}/${MOVIE}/${itemId}`}
                                                                        />
                                                                </DragSourceWrapperWithDropzonesContainer>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                                <div className={"program-list "}>
                                                    <div className="program-list-wrapper">
                                                        <h3 className="title-list text-regular"><Translation id="print_upcoming_movies"/></h3>
                                                    </div>
                                                    <ul className="grid-container">
                                                        {futureMovies.map((itemId, index) => relevantMovies[itemId] && (
                                                            <li key={index} className="item-drag">
                                                                <DragSourceWrapperWithDropzonesContainer
                                                                    index={index}
                                                                    id={itemId}
                                                                    type={'movie'}
                                                                    dndType={dndItemTypes.WEEK_PROGRAM_FLYER_ITEM_AD}
                                                                    >
                                                                        <ListItemMovieContainer
                                                                            itemData={relevantMovies[itemId]}
                                                                            isSelected={props.values.choosenMovies.order.includes(itemId)}
                                                                            pathnameEdit={`${basicUrl}/${MOVIE}/${itemId}`}
                                                                        />
                                                                </DragSourceWrapperWithDropzonesContainer>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className={"selections-item-periodes section-right" + displayDropzonesClass}>
                                                <PrintWeekProgramFlyerChoosenMoviesListContainer 
                                                    weekProgramFlyerData={weekProgramFlyerData}
                                                    displayDropzones={displayDropzones}
                                                    relevantMovies={relevantMovies}
                                                    basicUrl={basicUrl}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                   </div>
               </div>

               <PreviewPrintButtons 
                   hasChanges={hasChanges}
                   buttonTextTransId={buttonTextTransId}
                   printType={printType}
                   currentPrintID={currentPrintID}
                   printID={printID}
                   landscapeBoolean={landscapeBoolean}
                   activeWeek={activeWeek}
                   cinemaId={cinemaId}
                   printUpdateRequest={printUpdateRequest}
                   printFlyerRequest={printWeekProgramFlyerRequest}
               />
           </div>
                ) : (
                    <div>Dieses Feature ist nicht freigeschaltet. Bei Interesse kontaktieren Sie unseren <a className="support-mail text-regular-color cursor-pointer" href="mailto:info@pmkino.com">Support</a>.</div>
                )}
            </div>
        </WrapperPageSpinner>
    )
}

export default PrintWeekProgramFlyer

